import homeView from '../views/home';
import caseView from '../views/case';
import landingView from '../views/landing';
import aboutView from '../views/about';
import cultureView from '../views/culture';
import vacanciesView from '../views/vacancies';
import vacancyView from "../views/vacancy";
import error404View from "../views/error404";
import campaignView from "../views/campaign";
import servicesView from "../views/services";
import questionnaireView from "../views/questionnaire";

export default [
	homeView,
	caseView,
	landingView,
	aboutView,
	cultureView,
	vacanciesView,
	vacancyView,
	error404View,
	campaignView,
	servicesView,
	questionnaireView
];
